module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point3_1-ef514a44b5cd7f8d8da6ea4ef072ee1d.jpg";